import React from 'react'
import "./EditScheduleNotificationUpload.css"
import moment from 'moment'
import 'moment/locale/es';
import 'moment/locale/fr';
import ButtonBack from '../../ManageAllOffers/DetailedOfferScreen/ButtonBack/ButtonBack';
import { useTranslation } from 'react-i18next';
import { ScheduleNotification } from '../../../redux/slices/components/ScheduleNotifications/scheduleNotificationsSlice';
import CreateScheduleNotificationForm from '../CreateScheduleNotification/CreateScheduleNotificationForm/CreateScheduleNotificationForm';

type EditScheduleNotificationUploadrops = {
    id: string
    scheduleNotification: ScheduleNotification
}

const EditScheduleNotificationUpload = ({ scheduleNotification }: EditScheduleNotificationUploadrops) => {
   const { t, i18n } = useTranslation()
    moment.locale(i18n.language)

    return (
        <div className="con-create-notification">

            <div className="con-p-left-notification">
                <p className="fs-18 fw-600">
                    {t("Notifications:schedule:index:label_43")}
                </p>

                <p className="fs-12 mt-16">
                    {`${t("Notifications:schedule:index:label_29")}: ${moment().format("D MMMM YYYY - HH[h]mm")}`}
                </p>
            </div>
            

            <div className="flex flex-ai-center">
                <ButtonBack />
                <div className="line-gray-help"></div>
            </div>

            <div className="con-p-left-notification center">
                
                <div className="con-p-inputs-notification">
                    <CreateScheduleNotificationForm
                        type={"Edit"}
                        scheduleNotification={scheduleNotification}
                    />
                </div>
                
            </div>

        </div>
    )
}

export default EditScheduleNotificationUpload